import { render, staticRenderFns } from "./SnelStart.vue?vue&type=template&id=11f5989d&"
import script from "./SnelStart.vue?vue&type=script&lang=js&"
export * from "./SnelStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports